<script>
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    Spinner,
  },
};
</script>

<template>
  <div class="agent-placeholder">
    <Spinner />
    <p>{{ $t('CONVERSATION.CARD_CONTEXT_MENU.AGENTS_LOADING') }}</p>
  </div>
</template>

<style scoped lang="scss">
.agent-placeholder {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 0.75rem;
  min-width: 14rem;
  color: var(--context-menu-text-secondary) !important;

  p {
    margin: 0;
    font-size: var(--wlab-font-md);
    font-weight: 500;
  }
}
</style>
